import React from 'react';

export function SectionIntro({kicker, title, description, className = ''}) {
    return (
        <div className={`client-settings-intro section-intro-card box ${className}`}>
            <div>
                {kicker && <p className="client-settings-kicker">{kicker}</p>}
                <h1>{title}</h1>
                {description && <p>{description}</p>}
            </div>
        </div>
    );
}
